import type { LicenseType, LicenseTypeForm, AddLicenseToAccountForm, License } from '@/types/license.types';

import apiService from '@/services/api.service';

export default {
    /**
     * License
     */
    getLicenses: async (): Promise<License[]> => {
        const { status, data } = await apiService.get('licenses');

        if (status === 200) {
            return data as License[];
        }

        return [];
    },

    isLicensePresentInList: (licenses: License[], reference: string): boolean => {
        return licenses.some((license) => license.type.reference.includes(reference));
    },

    addLicenseToAccount: async (payload: AddLicenseToAccountForm) => {
        const { status } = await apiService.post('licenses', payload);

        return status === 200;
    },

    removeLicenseFromAccount: async (licenseId: string) => {
        const { status } = await apiService.delete(`licenses/${licenseId}`);

        return status === 204;
    },

    /**
     * License types
     */
    async getLicenseTypes(): Promise<LicenseType[]> {
        const { status, data } = await apiService.get('license-types');

        return status === 200 ? data : [];
    },

    licenseTypeFormToPayload(form: Partial<LicenseTypeForm>) {
        if (form.reference === '') {
            delete form.reference;
        }

        if (form.resource_type === undefined) {
            delete form.resource_type;
            delete form.resources;
        }

        return form;
    },

    async addLicenseType(licenseType: LicenseTypeForm): Promise<boolean> {
        const { status } = await apiService.post('license-types', this.licenseTypeFormToPayload(licenseType));

        return status === 200;
    },

    async updateLicenseType(id: string, licenseType: Partial<LicenseTypeForm>): Promise<boolean> {
        const { status } = await apiService.post(`license-types/${id}`, this.licenseTypeFormToPayload(licenseType));

        return status === 200;
    },

    async deleteLicenseType(id: string): Promise<boolean> {
        const { status } = await apiService.delete(`license-types/${id}`);

        return status === 204;
    },
};
